/**
 * Productkaart hover-video (em-product.liquid).
 * Alleen desktop: video speelt af op hover en pauzeert/reset bij weggaan.
 * Op touch-apparaten (geen hover) doet dit script niks.
 * Wordt één keer globaal geladen; werkt via event-delegatie op document,
 * dus ook voor kaarten die via AJAX-filtering/paginering worden bijgeladen.
 */
(function () {
  if (window.__emCardHoverVideoInit) return;
  window.__emCardHoverVideoInit = true;

  // Enkel op apparaten met een echte hover (muis) activeren.
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  document.addEventListener('mouseover', function (e) {
    var group = e.target.closest && e.target.closest('.group');
    if (!group) return;
    var video = group.querySelector('video[data-hover-video]');
    if (video && video.paused) {
      video.play().catch(function () {});
    }
  });

  document.addEventListener('mouseout', function (e) {
    var group = e.target.closest && e.target.closest('.group');
    if (!group || group.contains(e.relatedTarget)) return;
    var video = group.querySelector('video[data-hover-video]');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });
})();
